import React from 'react'
import { connect } from 'react-redux'
import Notifications from '../components/notifications'

const mapStateToProps = (state) => ({
  ...state.notifications
})

const mapDispatchToProps = dispatch => ({
  onRead: payload => dispatch({type: 'NOTIFICATIONS.READ', payload}),
  onDelete: payload => dispatch({type: 'NOTIFICATIONS.DELETE', payload}),
  onReadAll: payload => dispatch({type: 'NOTIFICATIONS.READ_ALL', payload}),
  onDeleteAll: payload => dispatch({type: 'NOTIFICATIONS.DELETE_ALL', payload}),
  onReceived: payload => dispatch({type: 'NOTIFICATIONS.RECEIVED', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)
